import { useAppStore } from '@/store/useAppStore.ts'
import { LoadUnit, type LoadUnit as LoadUnitType } from '@brt/shared-types'
import { ScrubInput, Select } from 'calc-controls'

const LOAD_OPTIONS = [
  { value: LoadUnit.MA, shortLabel: 'mA', fullLabel: 'Milliamps (mA)' },
  { value: LoadUnit.A, shortLabel: 'A', fullLabel: 'Amps (A)' },
  { value: LoadUnit.MW, shortLabel: 'mW', fullLabel: 'Milliwatts (mW)' },
  { value: LoadUnit.W, shortLabel: 'W', fullLabel: 'Watts (W)' },
  { value: LoadUnit.KW, shortLabel: 'kW', fullLabel: 'Kilowatts (kW)' },
]

const UNIT_SELECT_OPTIONS = LOAD_OPTIONS.map((opt) => ({
  value: opt.value,
  label: opt.fullLabel,
}))

export function LoadInput() {
  const primaryLoad = useAppStore((s) => s.load.loads[0])
  const updateLoad = useAppStore((s) => s.updateLoad)

  if (!primaryLoad) return null

  const isCurrent = primaryLoad.loadUnit === 'MA' || primaryLoad.loadUnit === 'A'
  const modeLabel = isCurrent ? 'Current' : 'Power'

  return (
    <div className="load-input">
      <div className="load-input__header">
        <span className={`load-input__mode load-input__mode--${isCurrent ? 'current' : 'power'}`}>
          {modeLabel}
        </span>
      </div>
      <ScrubInput
        label="Load"
        value={primaryLoad.loadValue || 0}
        onChange={(v) => updateLoad(primaryLoad.id, { loadValue: v })}
        unit={LOAD_OPTIONS.find((o) => o.value === primaryLoad.loadUnit)?.shortLabel ?? ''}
        min={0}
        step={0.1}
        decimals={3}
      />
      <Select
        label="Unit"
        options={UNIT_SELECT_OPTIONS}
        value={primaryLoad.loadUnit}
        onChange={(v) => updateLoad(primaryLoad.id, { loadUnit: v as LoadUnitType })}
      />
    </div>
  )
}
